import { Alert, AlertTitle } from "@mui/material"
import { TbAlertTriangle } from "react-icons/tb"

type WarningType = {
    children: React.ReactNode
}

const WarnAlert = ({ children }: WarningType) => {
    return <Alert severity="warning" sx={{ boxShadow: '1px 1px 5px rgba(0,0,0,0.2)' }}>
        <AlertTitle>
            <TbAlertTriangle />
            {children}
        </AlertTitle>
    </Alert>
}

export default WarnAlert;
